import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["directionInput", "amount", "notes", "reviewButton", "formStage", "confirmStage", "summary"];

  connect() {
    this.checkFormValid();
  }

  checkFormValid() {
    const amountValid = this.parsedAmount() > 0;
    const notesValid = this.notesTarget.value.trim() !== "";
    this.reviewButtonTarget.disabled = !(amountValid && notesValid);
  }

  review() {
    const direction = this.selectedDirection();
    const awardName = this.element.dataset.awardName;
    this.summaryTarget.textContent = `This will ${direction.toUpperCase()} $${this.parsedAmount().toFixed(2)} to ${awardName} with the note: "${this.notesTarget.value}"`;
    this.formStageTarget.hidden = true;
    this.confirmStageTarget.hidden = false;
  }

  back() {
    this.confirmStageTarget.hidden = true;
    this.formStageTarget.hidden = false;
  }

  confirm(event) {
    event.currentTarget.disabled = true;
    this.element.querySelector("form").requestSubmit();
  }

  parsedAmount() {
    return parseFloat(this.amountTarget.value.replace(/,/g, ""));
  }

  selectedDirection() {
    const checked = this.directionInputTargets.find(input => input.checked);
    return checked ? checked.value : "credit";
  }
}
